export default __webpack_public_path__ + "static/media/3 - Буккроссинг.29076b78.jpg";